import { Injectable } from '@angular/core';
import {HttpHelperService} from "./http-helper.service";
import {User} from "./models/User/User";
import {Property} from "./models/User/Property";
import {UserGetResult} from "./models/User/UserGetResult";
import {ApiResult} from "./models/ApiResult";
import {RemoveAccountReasonResult} from "./models/User/RemoveAccountReason";

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpService: HttpHelperService) { }

  public getUserData(fromCache: boolean = false) {
    return new Promise<UserGetResult>((resolve, reject) => {
      this.httpService.get<UserGetResult>("user")
        .then(r => {
            resolve(new UserGetResult(r));
          }
        )
        .catch(e => reject(e));
    })
  }
  public saveUser(user: any) {
    return new Promise<ApiResult>((resolve, reject) => {
      this.httpService.post<ApiResult>("user/save", user)
        .then(r => resolve(new ApiResult(r)))
        .catch(e => reject(e));
    });
  }
  public userSetProperties(properties: Property[]) {
    return new Promise<ApiResult>((resolve, reject) => {
      this.httpService.post<ApiResult>("user/setproperties", properties)
        .then(r => resolve(new ApiResult(r)))
        .catch(e => reject(e));
    })
  }
  public userSetProperty(key: string, value: string) {
    const properties = [];
    properties.push(new Property({ key: key, value: value }));
    return this.userSetProperties(properties);
  }
  public getUserRemoveAccountReasons(): Promise<RemoveAccountReasonResult> {
    return new Promise<RemoveAccountReasonResult>((resolve, reject) => {
      this.httpService.get("user/reasons-to-delete")
        .then(r => resolve(new RemoveAccountReasonResult(r)))
        .catch(e => reject(e));
    });
  }
  public removeUserAccount(reasonId: number): Promise<ApiResult> {
    return new Promise<ApiResult>((resolve, reject) => {
      this.httpService.delete(`user/${reasonId}`)
        .then(r => resolve(new ApiResult(r)))
        .catch(e => reject(e));
    })
  }
  public userSetConsent(consentUid: string, value: boolean) {
    return new Promise<ApiResult>((resolve, reject) => {
      this.httpService.post<ApiResult>("user/setconsent", { consentUid, value }).then((result: ApiResult) => {
        resolve(result);
      }).catch(error => {
        reject(error);
      })
    });
  }
  public MSISDNConfirmationSend(msisdn: string): Promise<ApiResult> {
    return new Promise<ApiResult>((resolve, reject) => {
      this.httpService.post<ApiResult>("user/mobile-confirm-send", { msisdn: msisdn }).then((result: ApiResult) => {
        resolve(result);
      }).catch(error => {
        reject(error);
      });
    });
  }
  public MSISDNConfirmation(msisdn: string, pin: string): Promise<ApiResult> {
    return new Promise<ApiResult>((resolve, reject) => {
      this.httpService.post<ApiResult>("user/mobile-confirm", { msisdn: msisdn, pin: pin }).then((result: ApiResult) => {
        resolve(result);
      }).catch(error => {
        reject(error);
      });
    });
  }
  public EmailConfirmationSend(email: string): Promise<ApiResult> {
    return new Promise<ApiResult>((resolve, reject) => {
      this.httpService.post<ApiResult>("user/email-confirm-send", { email: email }).then((result: ApiResult) => {
        resolve(result);
      }).catch(error => {
        reject(error);
      });
    });
  }
  public EmailConfirmation(email: string, pin: string): Promise<ApiResult> {
    return new Promise<ApiResult>((resolve, reject) => {
      this.httpService.post<ApiResult>("user/email-confirm", { email: email, pin: pin }).then((result: ApiResult) => {
        resolve(result);
      }).catch(error => {
        reject(error);
      });
    });
  }
  // reset hasła
  // public passwordReset(username: string) {
  //
  // }
  // zmiana hasła
  // public changePassword(odlPassword: string, newPassword: string) {
  //
  // }
}
